import type { SelectOption } from '@/components/ui/SelectOptions/types';
import type { GetCompaniesResponseDTO } from '@/core/dto/company/get-companies';

export class GetCompaniesMapper {
	constructor(private readonly data: GetCompaniesResponseDTO) {}

	toDomain(): SelectOption[] {
		return this.data.map((value) => ({
			value: value.id,
			label: value.name
		}));
	}
}
